import { matchPath } from 'react-router-dom';

import RoutePaths from '../router/RoutePaths';

/**
 * True when the user is on the cross-space "All Tasks" list route, which has no
 * single active space. `useGetActualSpaceId` cannot detect this: it returns the
 * persisted last-visited space, which survives navigation into All Tasks (#2683).
 *
 * Uses `matchPath` on the live pathname rather than `useMatch`: the create-item
 * modal renders outside the <Router> (ModalProvider wraps RouterProvider in
 * App.tsx) and `useMatch` hard-throws with no Router context. Entering/leaving
 * the All Tasks route fully remounts the view, so an unsubscribed read is stable.
 */
export const useIsAllTasksView = () => {
  return matchPath(RoutePaths.Organization.children.AllTasks, window.location.pathname) != null;
};
